var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 4,
    fill: "#E5F5E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url('/location-sets/ec0e7dd6-6ee8-425d-9824-40e3fe85cb14?mapStyle=Light&mapBounds=-11.3954116,-85.051129,67.757684,85.0511288#clip0_31786_50164')"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 17c-7.076 0-12.8 5.76-12.8 12.88C21.2 39.54 34 53.8 34 53.8s12.8-14.26 12.8-23.92C46.8 22.76 41.077 17 34 17Z",
    fill: "#007934",
    stroke: "#fff",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8 17C31.723 17 26 22.76 26 29.88c0 9.66 12.8 23.92 12.8 23.92s12.8-14.26 12.8-23.92C51.6 22.76 45.877 17 38.8 17Z",
    fill: "#007934",
    stroke: "#fff",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 30.6,
    r: 4.8,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31786_50164"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20 15)",
    d: "M0 0h33v41H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocations);
export default __webpack_public_path__ + "static/media/pin_locations.3075fb8fe3a3faf04d65fbd576433595.svg";
export { ForwardRef as ReactComponent };